<template>
  <vs-prompt
    title="OTP Authentication"
    type="confirm"
    accept-text="OK"
    @cancel="cancelled"
    @accept="accepted"
    @close="cancelled"
    :active.sync="activeSync"
    :is-valid="otp !== ''"
  >
    <div class="con-2fa-otp-prompt">
      <div v-if="otpRequired">
        Please enter the OTP sent to
        <span 
          class="bold-text" 
          v-if="loginRequestData && loginRequestData.mfa_type === mfaType.EMAIL">
          {{ this.email }}.
        </span>
        <span v-else>
          your registered
          <span class="bold-text">Authenticator</span> 
          application.
        </span>
        <vs-input label="OTP" v-model="otp" />
        <br />
        <vs-button
          @click="resendOTP()"
          :disabled="resendOTPDisabled"
          v-if="loginRequestData && loginRequestData.mfa_type === mfaType.EMAIL"
        >
          Resend OTP {{ this.resendOTPTimer ? `(${this.resendOTPTimer})` : '' }}
        </vs-button>
      </div>
    </div>
  </vs-prompt>
</template>
<script>
import { MFA_TYPE } from '../constants';

export default {
  props: {
    active: Boolean,
    email: String,
    otpRequired: Boolean,
    password: String,
    loginRequestData: Object,
  },
  data() {
    return {
      otp: '',
      activeSync: this.active,
      resendOTPDisabled: true,
      resendOTPTimer: 60,
      resendOTPTimerId: null,
      clientId: process.env.VUE_APP_CLIENT_ID,
    };
  },
  watch: {
    activeSync: function (val) {
      this.$emit('update:active', val);
    },
    active: function (val) {
      this.activeSync = val;
      if (val) {
        this.otp = '';

        if (this.otpRequired) {
          this.resendOTPCountdown();
        }
      }
    },
  },
  computed: {
    mfaType(){
      return MFA_TYPE;
    }
  },
  mounted() {},
  methods: {
    async cancelled() {
      // this.activeSync = true
      clearInterval(this.resendOTPTimerId);
    },

    async accepted() {
      // this is to make sure the dialog doesn't disappear before verification happen.
      this.activeSync = true;

      if (this.debugConsole) console.log('Verify OTP');

      if (this.otpRequired) {
        let payload = {};
        payload.username = this.email;
        payload.password = this.password;
        payload.otp = this.otp;
        if (this.$store.getters.otpKeyGetter) {
          payload.otp_key = this.$store.getters.otpKeyGetter;
        }
        
        if (this.debugConsole) console.log('Payload for verify OTP', payload);
        this.$store.commit('UPDATE_OTP_VALUE', this.otp); // saving OTP value
        this.$emit('verify', true);
      }
    },

    resendOTPCountdown() {
      this.resendOTPDisabled = true;
      this.resendOTPTimer = 60;
      this.resendOTPTimerId = setInterval(() => {
        this.resendOTPTimer -= 1;
        if (this.resendOTPTimer <= 0) {
          this.resendOTPDisabled = false;
          this.resendOTPTimer = false; // removing the count from text
          clearInterval(this.resendOTPTimerId);
        }
      }, 1000);
    },

    resendOTP() {
      this.resendOTPCountdown();

      let payload = {};
      payload.username = this.email;
      payload.password = this.password;

      this.checkLoginOTP(payload).then((res) => {
        if (res.status === 200 && res.data.required) {
          if (this.debugConsole) console.log(res.data);
        } else {
          this.$vs.notify({
            title: 'Error',
            text: `Failed to send OTP: ${res.data}`,
            color: 'danger',
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.con-2fa-otp-prompt {
  padding: 0px 10px 10px 10px;
}
  
.con-2fa-otp-prompt .vs-input {
  width: 100%;
  margin-top: 10px;
}
  
.con-text-noti p {
  color: #ffffff;
}
  
.my-box {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0.5rem;
  font-size: 1rem;
}

.bold-text {
  font-weight: 700;
}


  
</style>
